// extracted by mini-css-extract-plugin
export var adjacentSlide = "_tf-9";
export var arrowButtonContainer = "_tf-5";
export var arrowButtonIcon = "_tf-6";
export var carouselArrowButton = "_tf-2";
export var carouselElementContainer = "_tf-1";
export var currentSlide = "_tf-8";
export var left = "_tf-3";
export var otherSlide = "_tf-a";
export var productCarouselContainer = "_tf-0";
export var right = "_tf-4";
export var sliderOverflow = "_tf-7";